import { createContext } from 'react';

const commentContext = createContext();

export default commentContext;
